// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-edition-header[data-v-463fd55c] {\n  border-bottom: 2px #ff7058 solid;\n}\n.icon-view__extended[data-v-463fd55c] .dot em {\n  margin-top: -2px !important;\n  margin-left: 2px !important;\n}\n.callout__extended[data-v-463fd55c] .bg-secondary-3 .row-container > .col.p-2.ml-2 {\n  padding: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
